import { client } from 'app/http';

export const acceptInvitation = async (id: string) => {
  const { data } = await client.post(`/invitations/${id}/accept`);
  return data;
};
